document.addEventListener('DOMContentLoaded', function () {
  const urlParams = new URLSearchParams(window.location.search);
  const productSku = urlParams.get("product_sku");
  const productTitle = urlParams.get("product_title");
  if (productSku || productTitle) {
    const sku = productSku ? decodeURIComponent(productSku) : "";
    const title = productTitle ? decodeURIComponent(productTitle) : "";
    const combinedInfo = `Item Code：${sku}　Item Name：${title}`;
    const targetElement = document.querySelector('[name="contact[商品名-品番-no]"]');
    if (targetElement) {
      const pTag = document.createElement('p');
      pTag.textContent = combinedInfo;
      pTag.style.fontSize = "14px";
      pTag.style.padding = "14px";
      pTag.style.backgroundColor = "#f5f5f5";
      pTag.style.borderBottom = "1px solid #ccc";
      pTag.style.margin = "5px 0";
      targetElement.replaceWith(pTag);
      const hiddenInput = document.createElement('input');
      hiddenInput.type = 'hidden';
      hiddenInput.name = 'contact[商品名-品番-no]';
      hiddenInput.value = combinedInfo;
      pTag.after(hiddenInput);
    }
  }

  const contactForm = document.getElementById('contact-us-page');
  if (!contactForm) return;
  const submitButton = contactForm.querySelector('button[type="submit"]');
  let isSubmitting = false;
  const defaultButtonText = submitButton ? submitButton.textContent : '';
  contactForm.addEventListener('submit', function (event) {
    if (isSubmitting) {
      event.preventDefault();
      return;
    }
    isSubmitting = true;
    if (submitButton) {
      submitButton.disabled = true;
      submitButton.setAttribute('aria-disabled', 'true');
      submitButton.textContent = '送信中...';
    }
  });

  window.addEventListener('pageshow', function () {
    isSubmitting = false;
    if (submitButton) {
      submitButton.disabled = false;
      submitButton.removeAttribute('aria-disabled');
      submitButton.textContent = defaultButtonText;
    }
  });
});